import { MDSDropdown } from '@marqvision/mds-v2';
import { useReportReason } from '~/components/Filters/@hooks';
import { ResponsiveProps } from '~/components/Responsive/@types';

export const ReportReasonFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const reportReason = useReportReason();

  return (
    <MDSDropdown
      label="Report reason"
      value={reportReason.selected}
      list={reportReason.list}
      isDisabled={reportReason.disabled}
      isLoading={reportReason.isFetching}
      onChange={(value) => reportReason.select(value)}
      modules={[{ type: 'filter-button', size }]}
    />
  );
};
